import { inject, InjectionToken } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PartnerService } from '@galaxy/partner';
import { of } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay } from 'rxjs/operators';
import { AiKnowledgeConfig } from '@galaxy/ai-knowledge';

export const AI_KNOWLEDGE_CONFIG = new InjectionToken<AiKnowledgeConfig>(
  '[Partner Center Client]: Token for AI Knowledge config',
  {
    providedIn: 'root',
    factory: function (): AiKnowledgeConfig {
      const partnerService = inject(PartnerService);

      const accountGroupId$ = of('');
      const marketId$ = of('');
      const partnerId$ = partnerService.getPartnerId().pipe(
        map((partnerId) => partnerId),
        filter<string>(Boolean),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
      );

      const manageKnowledgeUrl$ = of('/ai-knowledge');

      const businessProfileUrl$ = of('');

      const showBusinessProfileSource$ = of(false);

      return {
        accountGroupId$,
        marketId$,
        partnerId$,
        manageKnowledgeUrl$,
        businessProfileUrl$,
        showBusinessProfileSource$,
      };
    },
  },
);
